import React from "react";
import Logo from '../Images/Logo.png'
import Form from 'react-bootstrap/Form';
import { Link } from "react-router-dom";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";

const Footer = () => {
    return(
        <>
            <div className="container" style={{ marginTop: "100px" }}>
            <div className="row">
                <div className="col-md-4">
                <img className="mt-5" src={Logo} alt="Logo" />
                <p className="mt-4">
                    A global digital agency specializing in high-end software development,
                    AI solutions, and strategic brand identity for B2B enterprises.
                </p>
                <div className="d-flex gap-4" style={{fontSize: '20px'}}>
                    <a href="https://instagram.com/chilicomtech" target="_blank" rel="noopener noreferrer">
                        <FaInstagramSquare className="icons" />
                    </a>

                    <a href="https://wa.me/2349060409968" target="_blank" rel="noopener noreferrer">
                        <IoLogoWhatsapp className="icons" />
                    </a>

                    <a href="https://facebook.com/Chilicomtech" target="_blank" rel="noopener noreferrer">
                        <FaFacebook className="icons" />
                    </a>
                </div>               
                </div>


                <div className="col-md-2">
                <h4 className="mt-4 fw-bold">Services</h4>
                <p className="mt-5 footer-link">Brand Strategy</p>
                <p className="mt-4 footer-link">Web Development</p>
                <p className="mt-4 footer-link">Enterprise Software</p>
                <p className="mt-4 footer-link">AI & ML Solutions</p>
                <p className="mt-4 footer-link">Mobile Platforms</p>
                </div>

                <div className="col-md-2">
                <h4 className="mt-4 fw-bold">Company</h4>
                    <Link to="/about" className="mt-4 foot footer-link d-inline-block">
                    About
                    </Link>
                <p className="mt-4 footer-link">Careers</p>
                <p className="mt-4 footer-link">Our Process</p>
                <p className="mt-4 footer-link">Insights</p>
                    <Link to="/contact" className="mt-2 foot footer-link d-inline-block">
                    Contact
                    </Link>                
                </div>

                <div className="col-md-4">
                <h4 className="mt-5 fw-bold">Join our newsletter</h4>
                <p>Weekly Insights on tech trends and digital strategy</p>
                <Form.Control style={{fontSize: '15px'}} type="email" placeholder="email@company.com" />
                <button className="butt mt-2 w-100">Subscribe</button>
                </div>
            </div>
            <div className="footer-divider"></div>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">

            <small className="mb-2 mb-md-0 text-center text-md-start">
                © 2026 Chilicom Technologies
            </small>

            <div className="d-flex flex-wrap justify-content-center mb-2">
            <a href="/about" className="text-muted footer-links text-decoration-none">
                <small>Privacy Policy</small>
            </a>

            <a href="/about" className="text-muted footer-links text-decoration-none">
                <small>Terms of Service</small>
            </a>

            <a href="/about" className="text-muted footer-links text-decoration-none">
                <small>Cookie Policy</small>
            </a>
            </div>

            </div>
            

            </div>

        </>
    )
}

export default Footer;